<template>
  <div class="record-box">
    <div class="history-list-div" v-if="historyList.length">
      <div class="record-div">
        <div class="record-div-top hasPadding">
          <p>搜索历史</p>
          <span class="icon iconfont icon-shanchu" @click="searchClearn"></span>
        </div>
      </div>
      <ul class="hasPadding record-ul">
        <li
          class="record-li"
          v-for="(item, index) in historyList"
          v-show="index < 3 || showMore"
          @click="handleClick(item)"
        >
          <span class="icon iconfont icon-clock1"></span>
          <span class="record-s1">{{ item }}</span>
        </li>
      </ul>
      <p
        class="record-more"
        @click="handleShowMore"
        v-show="historyList.length > 3"
      >
        <span>更多搜索历史</span>
        <span
          :class="[
            'icon',
            'iconfont',
            showMore ? 'icon-arrowup' : 'icon-arrowdown '
          ]"
        ></span>
      </p>
    </div>
    <!-- <div class="b-line"></div> -->
    <!-- <div class="" v-if="hotSearchList">
            <div class="record-div">
                <div class="record-div-top hasPadding">
                    <p>热门搜索</p>

                </div>
            </div>
            <ul class="hasPadding record-ul record-ul2">
                <li class="record-li" v-for="(item,index) in hotSearchList" :key="index" @click="handleClick(item)">
                    <span :style="{color:hotIndexColor(index)}">{{index + 1}}</span>
                    <span class="record-s2">{{item.hotword}}</span>
                </li>

            </ul>
    </div>-->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { search } from '@/api/ajax.js';
export default {
  data() {
    return {
      showMore: false,
      hotSearchList: null
    };
  },
  computed: {
    ...mapState({
      historyList: state => state.search.historyList
    })
  },
  methods: {
    ...mapActions(['searchWordActions', 'searchClearn']),
    handleShowMore() {
      this.showMore = !this.showMore;
    },
    recordClearn() {},
    hotIndexColor(index) {
      if (index == 0) {
        return '#E42B18';
      } else if (index == 1) {
        return ' #FF7100';
      } else if (index == 2) {
        return '#FFB900';
      } else {
        return '#707070';
      }
    },
    handleClick(item) {
      if (typeof item === 'object') {
        this.searchWordActions(item.hotword);
      } else {
        this.searchWordActions(item);
      }

      this.$emit('search-input-enter', 'enter');
    }
  },
  created() {
    // search.hotSearch().then(res => {
    //   this.hotSearchList = res.data.data
    // })
  }
};
</script>

<style lang="less" scoped>
.record-box {
  margin-top: 0.3333rem /* 25/75 */;
  .history-list-div {
    // margin: .3067rem/* 23/75 */
    // 0;
    border-bottom: 0.2667rem /* 20/75 */ solid #eee;
    padding-bottom: 0.3067rem /* 23/75 */;
    margin-bottom: 0.3067rem /* 23/75 */;
  }
  // 历史记录
  .record-div {
    position: relative;
    padding-bottom: 0.25rem;
    &:after {
      content: ' ';
      width: 100%;
      height: 1px;
      background: #d8d8d8;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      transform: scaleY(0.5);
      transform-origin: 0 100%;
      // margin-top: .3333rem /* 25/75 */;
    }
    .record-div-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      &:before {
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
        width: 0.0533rem /* 4/75 */;
        height: 0.3733rem /* 28/75 */;
        background: #027cfa;
      }
      p {
        font-size: 0.4rem /* 30/75 */;
        color: #707070;
      }
      .icon-shanchu {
        font-size: 0.5rem /* 24/75 */;
      }
    }
  }
  // 历史
  .record-ul {
    margin-top: 0.32rem /* 24/75 */;
    .record-li {
      display: flex;
      align-items: center;
      margin-bottom: 0.6267rem /* 47/75 */;
      .record-s1 {
        font-size: 0.32rem /* 24/75 */;
        color: #161616;
        margin-left: 0.1333rem /* 10/75 */;
      }
    }
  }
  .record-more {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.32rem /* 24/75 */;
    color: #707070;
    span:nth-child(1) {
      margin-right: 0.2667rem /* 20/75 */;
    }
    span:nth-child(2) {
      font-size: 0.25rem;
    }
  }
  .b-line {
    width: 100%;
    height: 0.2667rem /* 20/75 */;
    background: #eeeeee;
    margin: 0.3067rem /* 23/75 */ 0;
  }
  // 热门
  .record-ul2 {
    span {
      font-size: 0.4rem /* 30/75 */;
      margin-right: 0.2rem;
    }
  }
}
</style>
